import Axios from 'axios';
import * as AccountRequest from '@/models/accountRequest';
import * as AccountResponse from '@/models/accountResponse';

export type Account = AccountResponse.AccountDetailResponse;

export interface SearchCondition {
  keyWord: string;
  perPage: number;
  page: number;
  sort: string;
}

interface State {
  loading: boolean;
  countAll: number;
  users: Account[];
  searchCondition: SearchCondition;
}
const mapState: State = {
  loading: false,
  countAll: 0,
  users: new Array<Account>(),
  searchCondition: {
    keyWord: '',
    perPage: 20,
    page: 1,
    sort: '',
  },
};

const mapActions = {
  async searchUsers({ commit }: any, searchCondition: SearchCondition) {
    commit('setLoading', true);

    const request: AccountRequest.AccountRequest = {
      id: undefined,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      keyWord: searchCondition.keyWord,
      perPage: searchCondition.perPage,
      page: searchCondition.page,
      sort: searchCondition.sort,
    };
    const response = await Axios.post('/api/Account/Search', request).catch((error) => {
      commit('setLoading', false);
      throw error;
    });

    const data = response.data as AccountResponse.AccountListResponse;
    commit('searchUsers', data);
  },
  async createUser({ commit }: any, user: Account) {
    if (!user || !user.lastName || !user.firstName) {
      throw new Error('氏名を入力してください。');
    }
    if (!user.lastNameKana || !user.firstNameKana) {
      throw new Error('カナ氏名を入力してください。');
    }
    const request: AccountRequest.AccountRequest = {
      id: undefined,
      userId: user.userId,
      lastName: user.lastName,
      firstName: user.firstName,
      lastNameKana: user.lastNameKana,
      firstNameKana: user.firstNameKana,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Create', request).catch((error) => {
      throw new Error('管理者の登録に失敗しました。');
    });
    return response.data;
  },
  async editUser({ commit }: any, user: Account) {
    if (!user || !user.id) {
      throw new Error('変更する管理者を選択してください。');
    }
    if (!user || !user.lastName || !user.firstName) {
      throw new Error('氏名を入力してください。');
    }
    if (!user.lastNameKana || !user.firstNameKana) {
      throw new Error('カナ氏名を入力してください。');
    }
    const request: AccountRequest.AccountRequest = {
      id: user.id,
      userId: user.userId,
      lastName: user.lastName,
      firstName: user.firstName,
      lastNameKana: user.lastNameKana,
      firstNameKana: user.firstNameKana,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Edit', request).catch((error) => {
      throw new Error('管理者の変更に失敗しました。');
    });
    commit('changeUser', user);
    return response.data;
  },
  async deleteUser({ commit }: any, id: string) {
    if (!id) {
      throw new Error('削除する管理者を選択してください。');
    }
    const request: AccountRequest.AccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Delete', request).catch((error) => {
      throw new Error('管理者の削除に失敗しました。');
    });
    commit('removeUser', id);
    return response.data;
  },
  async resetPassword({ commit }: any, id: string) {
    if (!id) {
      throw new Error('パスワード初期化する管理者を選択してください。');
    }
    const request: AccountRequest.AccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Reset', request).catch((error) => {
      throw new Error('パスワードの初期化に失敗しました。');
    });
    return response.data;
  },
  async getUser({ commit }: any, id: string) {
    const request: AccountRequest.AccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Detail', request).catch((error) => {
      throw error;
    });
    return response.data as Account;
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  searchUsers(state: State, data: AccountResponse.AccountListResponse) {
    state.countAll = data.countAll;
    state.users = data.accountList;
    state.loading = false;
  },
  changeUser(state: State, user: Account) {
    const findIndex = state.users.findIndex((value) => {
      return (value.id === user.id);
    });
    if (findIndex >= 0) {
      state.users.splice(findIndex, 1, user);
    }
  },
  removeUser(state: State, id: string) {
    const findIndex = state.users.findIndex((value) => {
      return (value.id === id);
    });
    if (findIndex >= 0) {
      state.users.splice(findIndex, 1);
    }
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
